import { AxiosResponse } from "axios";
import { syncAmplitudeUserFromApplicationEmail } from "@/services/Amplitude";
import client from "../client";
import { postCreateApplicationConfig } from "./PostCreateApplicationConfig";
import { postCreateApplicationResponse } from "./types";

const postCreateApplication = async ({
  formData,
}: {
  formData: any;
}): Promise<AxiosResponse<postCreateApplicationResponse>> => {
  await syncAmplitudeUserFromApplicationEmail(formData);

  return client({
    ...postCreateApplicationConfig,
    data: { ...formData },
  });
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  postCreateApplication,
};
